import { MaskedLine, Overline, FadeUp } from "./Reveal";

export const PageHeader = ({ overline, title, subtitle, testId }) => (
  <section className="pt-32 pb-16 lg:pt-40 lg:pb-24" data-testid={testId}>
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <FadeUp>
        <Overline>{overline}</Overline>
      </FadeUp>
      <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter text-primary leading-[0.95] max-w-4xl">
        {title.map((line, i) => (
          <MaskedLine key={i} delay={0.1 + i * 0.12}>{line}</MaskedLine>
        ))}
      </h1>
      {subtitle && (
        <FadeUp delay={0.4} className="mt-8 max-w-2xl">
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">{subtitle}</p>
        </FadeUp>
      )}
    </div>
  </section>
);
